import Head from 'next/head'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import MapPlan from '../../components/map_plan.component'
import OpenHours from '../../components/open-hours/open_hours.component'
import { serverForCityCardArticleImages } from '../../config'
import { useAppContext } from '../../context/siteMapContext'
import { imageLoaderForStaticImages } from '../../context/utils'
import useCityCard from '../../hooks/useCityCard'

export const CityCardDetails = () => {
  const { highContrastOn } = useAppContext()
  const { query } = useRouter()
  const { contentId } = query
  const cityCard = useCityCard(contentId as string)

  const lat = useMemo(() => {
    if (!cityCard) return 0
    return Number.parseFloat(cityCard.lat)
  }, [cityCard])

  const lon = useMemo(() => {
    if (!cityCard) return 0
    return Number.parseFloat(cityCard.lon)
  }, [cityCard])

  return (
    <>
      <Head>
        <meta property="og:title" content="Városkártya" />
        <meta property="og:description" content="Budapest 18 kerület önkormányzati weboldal" />
        <meta property="og:image" content="https://webteszt.bp18app.hu/body/logo.jpg" />
        <title>Városkártya</title>
        <meta
          name="description"
          content="Budapest 18 kerület önkormányzati weboldal"
        />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="grid grid-cols-12 text-article pb-22.5 gap-desktop font-montserrat article-list-styles article-content clear-a pt-36 2xl:pt-0">
        <div className="col-start-2 2xl:col-start-3 col-span-10 2xl:col-span-8">
          {cityCard && (
            <>
              <div>
                <p className="font-montserrat font-medium text-[2.4rem]">
                  {cityCard.name}
                </p>
              </div>
              <div className="w-full 2xl:flex 2xl:flex-row gap-8 pb-8 pt-10">
                <div className="2xl:w-1/2 w-full grid mb-10">
                  <p className="font-montserrat font-regular text-[1.8rem]">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: cityCard.opening_hours.comment,
                      }}
                    ></p>
                    {cityCard.home_page_url && (
                      <p className="pt-10">
                        Weboldal:{' '}
                        <a
                          target="_blank"
                          href={cityCard.home_page_url}
                          rel="noreferrer"
                        >
                          {cityCard.home_page_url}
                        </a>
                      </p>
                    )}
                  </p>
                  <p className="font-montserrat font-semibold text-[2.2rem] leading-[28px]">
                    <p className="text-[#c4002d]">
                      {cityCard.discount}% kedvezmény
                    </p>
                    <p>Kategória: {cityCard.category}</p>
                  </p>
                  <OpenHours openHours={cityCard.opening_hours} />
                </div>
                <div className="2xl:w-1/2 w-full h-[600px] grid">
                  <Image
                    loader={imageLoaderForStaticImages}
                    src={`${serverForCityCardArticleImages}/${cityCard.base_img_url}`}
                    alt={cityCard.name}
                    title={cityCard.name}
                    height="321px"
                    width="100%"
                    objectFit="contain"
                    layout="responsive"
                  />
                </div>
              </div>
              <div className="w-full 2xl:flex 2xl:flex-row pb-8 pt-20">
                <div
                  className={`2xl:w-1/2 w-full h-[321px] grid p-8 mb-10 ${highContrastOn ? 'bg-[#303030]' : 'bg-[#ecf0f6]'
                    }`}
                >
                  <p
                    className={`font-montserrat font-regular text-[3rem] leading-[36px] ${highContrastOn ? 'text-[#fff]' : 'text-[#b6182d]'
                      }`}
                  >
                    Térkép
                  </p>
                  <p className="font-montserrat font-regular text-[2.4rem] leading-[20px]">
                    {cityCard.name}
                  </p>
                  <p className="font-montserrat font-regular text-[2.4rem] leading-[29px]">
                    {cityCard.address}
                  </p>
                </div>
                <div className="2xl:w-1/2 w-full h-[321px] grid">
                  <MapPlan
                    selectMarker={() => { }}
                    markerList={[
                      {
                        lat: lat,
                        lon: lon,
                        address: cityCard.address,
                      },
                    ]}
                    className="h-[321px]"
                    center={{
                      lat: lat,
                      lng: lon,
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default CityCardDetails
